import { Card, CardBody } from 'react-bootstrap';

export default function QuickExchangeInfoCard() {

  return (
    <Card className="account-card m-0">
      <CardBody className='p-0'>
        <div className=''>
          <div className='font-semibold text-16 mb-3'>Convert KAX to USDC on Polygon</div>
          <div>
            <ul className="mb-0 list-disc">
              {/* <li className="mb-2"><strong></strong></li> */}
              <li className="mb-2">You can swap your KAX tokens for USDC (Polygon) using Rango Exchange.</li>
              <li className="mb-2">Rango operates on the Polygon network, so you’ll need a small amount of POL to cover transaction fees for swapping, sending, or withdrawing tokens.</li>
            </ul>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}